import { api } from "../../services";
import Swal from "sweetalert2";

const wallets = {
  state: {
    pagination: [],
    data: [],
    wallet: {}
  },
  getters: {
    getWalletObject: (state) => (key, value) => {
      const object = state.data.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getWalletsArray: (state) => (key, value) => {
      if (state.data !== undefined) {
        return state.data.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
  },
  mutations: {
    SET_WALLETS(state, payload) {
      state.pagination = payload
      this.dispatch('getLeadsData', payload.data)
    },
    SET_WALLETS_DATA(state, payload) {
      payload.forEach(p => {
        const exist = state.data.find(e => {
          return e.id === p.id;
        });
        if (!exist) {
          state.data.push(p);
        }
      });
    },
    SET_WALLET(state, payload) {
      state.wallet = payload
    },
  },
  actions: {
    getWallets(context, payload) {

      api.get('/wallets', {
        params: payload
      }).then(response => {
        context.commit("SET_WALLETS", response.data);
        // context.commit("SET_WALLETS_DATA", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getWalletsData(context, payload) {
      let ids = [];
      payload.forEach(p => {
        const item = context.state.data.find(i => {
          return p === i.channel_id
        });
        if (item === undefined) {
          ids.push(p);
        }
      });
      if (ids.length > 0) {
        api.post(`/wallets`, { ids }).then(response => {
          context.commit("SET_WALLETS_DATA", response.data);
        }).catch(error => {
          if (error.response.status === 401) {
            this.dispatch('logoutUser');
          }
        });
      }
    },
    deleteWallet(context, payload) {
      api.delete(`/wallets/${payload.id}`).then(() => {
        this.dispatch('getWallets', payload.data)
      }).then(() => {
        Swal.fire(
          `${context.rootGetters.getTranslations('expression_906')}`,
          `${context.rootGetters.getTranslations('expression_970')}`,
          'success'
        )
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire(
            `${context.rootGetters.getTranslations('expression_406')}`,
            `${error.response.data.message}`,
            'warning'
          )
        }
      });
    },
    getWallet(context, payload) {
      context.commit("SET_WALLET", payload);
    },
   updateWallet(context, payload) {
  return api.put(`/wallets/${payload.id}`, payload).then(() => {
    
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: `${context.rootGetters.getTranslations('expression_933')}`,
      showConfirmButton: false,
      timer: 1500
    })
  }).catch(error => {
    if (error.response.status === 401) {
      this.dispatch('logoutUser');
    }
    throw error; // Re-throw para o componente tratar
  });
},
    addWallet(context, payload) {
      api.post(`/wallets`, payload).then(response => {
        this.dispatch('getWallets', { lead_id: payload.lead_id })
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: context.rootGetters.getTranslations('expression_971'),
          showConfirmButton: false,
          timer: 1500
        })
      }).catch(error => {
        if (error.response.status === 400) {
          Swal.fire({
            position: 'center',
            icon: 'warning',
            title: error.response.data.message,
            showConfirmButton: false,
            timer: 1500
          })
        }
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    deleteWalletMassive(context, payload) {
      api.post(`/wallets/massive/delete`, payload).then(() => {
        if (window.localStorage.getItem("user_id")) {

          setTimeout(() => {
            this.dispatch('getWallets', { user_id: window.localStorage.getItem("user_id") });
          }, 1200);

        }

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: `${context.rootGetters.getTranslations('expression_972')}`,
          showConfirmButton: false,
          timer: 1500
        });
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    transferWalletMassive(context, payload) {
      api.post(`/wallets/massive/transfer`, payload).then(() => {
        if (window.localStorage.getItem("user_id")) {

          setTimeout(() => {
            this.dispatch('getWallets', { user_id: window.localStorage.getItem("user_id") });
          }, 1200);

        }
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: context.rootGetters.getTranslations('expression_973'),
          showConfirmButton: false,
          timer: 1500
        });
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    shareWalletMassive(context, payload) {
      api.post(`/wallets/massive/share`, payload).then(() => {
        if (window.localStorage.getItem("user_id")) {

          setTimeout(() => {
            this.dispatch('getWallets', { user_id: window.localStorage.getItem("user_id") });
          }, 1200);

        }
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: "Carteira compartilhada com sucesso",
          showConfirmButton: false,
          timer: 1500
        });
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },

    removeShareWalletMassive(context, payload) {
      api.post(`/wallets/massive/remove-share`, payload).then(() => {
        if (window.localStorage.getItem("user_id")) {

          setTimeout(() => {
            this.dispatch('getWallets', { user_id: window.localStorage.getItem("user_id") });
          }, 1200);

        }
        const successMessage = "Compartilhamento removido com sucesso";
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: successMessage,
          showConfirmButton: false,
          timer: 1500
        });
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },


  },
}
export default wallets;
